<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :auto-fetch="false"
      :before-reset-search="beforeResetSearch"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockSynchronization.header.warehouseCode')" prop="warehouseCode">
            <BjInput
              v-model="queryParams.warehouseCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('BusinessStockSynchronization.header.warehouseCode')"
              clearable
              @keyup.enter.native="handleQuery"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockSynchronization.header.warehouseName')" prop="warehouseName">
            <BjInput
              v-model="queryParams.warehouseName"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('BusinessStockSynchronization.header.warehouseName')"
              clearable
              @keyup.enter.native="handleQuery"
            /> </el-form-item
        ></el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('table.statusText')" prop="status">
            <BjSelectLov
              v-model="queryParams.status"
              multiple
              lov-code="STOCK.RECORD_STATUS"
              :placeholder="$t('table.statusText')"
            /> </el-form-item
        ></el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockSynchronization.header.synchronisedTime')">
            <BjDateTimerangePicker v-model="queryParamsTime" :placeholder="$t('BusinessStockSynchronization.header.synchronisedTime')"/>
          </el-form-item
        ></el-col>
      </template>

      <template v-slot:tableOperation>
        <el-col>
          <el-button
            v-permission:BusinessStockSynchronizationAdd
            type="primary"
            class="main-btn"
            @click="onAdd"
            >{{ $t('addText') }}</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="{ row }">
              <template v-if="false" />
              <span v-else-if="col.prop === 'adjustCode'" class="link" @click="onDetail(row)">
                {{ row[col.prop] }}</span
              >
              <template v-else-if="col.prop === 'status'">
                {{ $store.state.values.STOCK_RECORD_STATUS.bjGet(row[col.prop]) }}
              </template>

              <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-button
                v-permission:BusinessStockSynchronizationIndex_Pass
                :disabled="row.status == 'success'"
                type="text"
                @click="onStatus('success', row)"
                >{{ $t('approvedText') }}</el-button
              >
              <!-- <el-button type="text"  @click="onEdit(row)" class='edit-btn'>{{ $t('editText') }}</el-button>
              <el-button
                :disabled="row.status"
                type="text"

                @click="onDelete(row)"
                 class='delete-btn'>{{ $t('delText') }}</el-button
              > -->
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <!-- <DataForm ref="DataForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" /> -->
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { stockApi } from '@/api';
// import DataForm from './components/DataForm.vue';
// import {  } from '@/utils/constants';
export default {
  name: 'BusinessStockSynchronization',
  components: {
    // DataForm,
  },
  mixins: [pageMiXin],
  data() {
    return {
      queryApi: stockApi.getAdjustRecords,
      // 查询参数
      queryParams: {
        adjustCode: null,
        endTime: null,
        startTime: null,
        status: [],
        warehouseCode: null,
        warehouseName: null,
      },
      labelsVersion: 11,
      labelList: [
        { label: 'BusinessStockSynchronization.table.adjustCode', prop: 'adjustCode', isCheck: true, disabled: false, width: 180 },
        { label: 'BusinessStockSynchronization.table.warehouseCode', prop: 'warehouseCode', isCheck: true, disabled: false, width: 180 },
        { label: 'BusinessStockSynchronization.table.warehouseName', prop: 'warehouseName', isCheck: true, disabled: false, width: 180 },
        { label: 'table.statusText', prop: 'status', isCheck: true, disabled: false },
        { label: 'BusinessStockSynchronization.table.lastUpdateName', prop: 'lastUpdateName', isCheck: true, disabled: false, width: 135 },
        { label: 'BusinessStockSynchronization.table.lastUpdateDate', prop: 'lastUpdateDate', isCheck: true, disabled: false, width: 135 },
        { label: 'table.remarkText', prop: 'remarks', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 120 },
      ],

      queryParamsTime: null,
    };
  },
  computed: {},
  watch: {
    queryParamsTime(v) {
      this.queryParams.startTime = (v || [])[0];
      this.queryParams.endTime = (v || [])[1];
    },
  },
  mounted() {
    this.queryParams.ruleId = this.$route.query.id || '';

    this.$refs.BjPage.fetchData();
  },
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    onDetail(row) {
      this.$toPage('BusinessStockSynchronizationDetail', {
        adjustId: row.adjustId,
      });
    },
    /** 禁用 */
    onStatus(flag, row) {
      this.$confirm(`${this.$t('toast.youAreTipText')} ${this.$t('BusinessStockSynchronization.review')} ${row.adjustCode}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.operationApi({
            id: row.adjustId,
            status: flag,
          });
        })
        .catch(() => {});
    },
    /** 删除操作 */
    // onDelete(row) {
    //   this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
    //     confirmButtonText: this.$t('toast.okText'),
    //     cancelButtonText: this.$t('toast.cancelText'),
    //     type: 'warning',
    //   })
    //     .then(() => {
    //       this.batchDeleteApi(row);
    //     })
    //     .catch(() => {});
    // },
    // /** 批量删除操作 */
    // onDeleteSelected() {
    //   if (!this.selectedRows.length) {
    //     this.$message.warning(this.$t('chooseText'));
    //     return;
    //   }
    //   const ids = this.selectedRows.map(e => e.id);
    //   this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
    //     confirmButtonText: this.$t('toast.okText'),
    //     cancelButtonText: this.$t('toast.cancelText'),
    //     type: 'warning',
    //   })
    //     .then(() => {
    //       this.batchDeleteApi({ ids: ids });
    //     })
    //     .catch(() => {});
    // },
    /** 新建 */
    onAdd() {
      this.$toPage('BusinessStockSynchronizationAdd');
      // this.$refs.DataForm.show();
    },
    /** 编辑操作 */
    onEdit(row) {
      // this.$refs.DataForm.show(this.$lodash.clone(row));
    },

    operationApi(API_DATA) {
      stockApi.statusAdjustRecords(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    // deleteApi(API_DATA) {
    //   stockApi.deleteOnlineShop(API_DATA).then(res => {
    //     if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
    //       this.$message.success(this.$t('toast.operationSuccessText'));
    //       setTimeout(() => {
    //         this.reFresh();
    //       }, 500);
    //     }
    //   });
    // },
    batchDeleteApi(API_DATA) {
      stockApi.deleteSurplusQtyReplenish(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
</style>
